import { findTarget } from '../../../../../utils/microcopy.utils'

export const getPageNumber = (pageNumber: number) => {
  if (typeof window !== 'undefined' && window.location.pathname) {
    const numberInUrl = window.location.pathname.match(/[0-9]+/)
    if (numberInUrl && numberInUrl[0]) {
      return parseInt(numberInUrl[0])
    }
  } else {
    if (pageNumber) {
      return pageNumber
    }
  }

  return 1
}

export const getMicrocopyData = (microcopy: any, microcopySetResources: any) => {
  return {
    noResultsSearch: () => findTarget(`NoResultsSearch.text`, microcopy.values || [], false),
    suggestedSearch1: () => findTarget(`SuggestedSearch1.text`, microcopy.values || [], false),
    suggestedSearch2: () => findTarget(`SuggestedSearch2.text`, microcopy.values || [], false),
    microcopyFeaturedText: () =>
      findTarget('FeaturedPILL.text', microcopySetResources?.values || [], false),
    onDemandFeaturedText: () =>
      findTarget('resource.7.OnDemandPILL.text', microcopySetResources?.values || [], false),
    inEnglishText: () =>
      findTarget('InEnglishPILL.text', microcopySetResources?.values || [], false) || 'In English',
    suggestedRow: () => findTarget(`SuggestedRow.text`, microcopy.values || [], false),
    suggestedSearchFilter1: () =>
      findTarget(`SuggestedSearchFilter1.text`, microcopy.values || [], false),
    searchResults: () => findTarget(`SearchResults.text`, microcopy.values || [], false),
    noResultsFilter: () => findTarget(`NoResultsFilter.text`, microcopy.values || [], false),
    suggestedFilter: () => findTarget(`SuggestedFilter.text`, microcopy.values || [], false),
    clearFilter: () => findTarget(`ClearFilter.text`, microcopy.values || [], false),
    allResources: () => findTarget('AllResources', microcopy.values || [], false),
    wantMore: () => findTarget('WantMore', microcopy.values || [], false),
    showMoreText: () => findTarget('ShowMore.text', microcopy.values || [], false),
    showLessText: () => findTarget('ShowLess.text', microcopy.values || [], false),
    filterByText: () => findTarget('Filter.text', microcopy.values || [], false),
    activeFiltersText: () => findTarget('ActiveFilter.text', microcopy.values || [], false),
    clearFiltersText: () => findTarget('CloseFilter.text', microcopy.values || [], false),
    applyFiltersText: () => findTarget('ApplyFilters.text', microcopy.values || [], false),
  }
}
